// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFileReassignmentDto } from './IFileReassignmentDto';
import {
    IFileReassignmentDtoFromJSON,
    IFileReassignmentDtoFromJSONTyped,
    IFileReassignmentDtoToJSON,
    IFileReassignmentDtoToJSONTyped,
} from './IFileReassignmentDto';

/**
 * 
 * @export
 * @interface ILetterOfMedicalNecessityCreateDto
 */
export interface ILetterOfMedicalNecessityCreateDto {
    /**
     * 
     * @type {string}
     * @memberof ILetterOfMedicalNecessityCreateDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ILetterOfMedicalNecessityCreateDto
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof ILetterOfMedicalNecessityCreateDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ILetterOfMedicalNecessityCreateDto
     */
    valid_to?: Date;
    /**
     * 
     * @type {number}
     * @memberof ILetterOfMedicalNecessityCreateDto
     */
    document_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ILetterOfMedicalNecessityCreateDto
     */
    employee_id: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ILetterOfMedicalNecessityCreateDto
     */
    claim_ids?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof ILetterOfMedicalNecessityCreateDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ILetterOfMedicalNecessityCreateDto
     */
    organization_path?: string;
    /**
     * 
     * @type {IFileReassignmentDto}
     * @memberof ILetterOfMedicalNecessityCreateDto
     */
    file_reassignment?: IFileReassignmentDto;
}

/**
 * Check if a given object implements the ILetterOfMedicalNecessityCreateDto interface.
 */
export function instanceOfILetterOfMedicalNecessityCreateDto(value: object): value is ILetterOfMedicalNecessityCreateDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('employee_id' in value) || value['employee_id'] === undefined) return false;
    return true;
}

export function ILetterOfMedicalNecessityCreateDtoFromJSON(json: any): ILetterOfMedicalNecessityCreateDto {
    return ILetterOfMedicalNecessityCreateDtoFromJSONTyped(json, false);
}

export function ILetterOfMedicalNecessityCreateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ILetterOfMedicalNecessityCreateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
        'document_id': json['document_id'] == null ? undefined : json['document_id'],
        'employee_id': json['employee_id'],
        'claim_ids': json['claim_ids'] == null ? undefined : json['claim_ids'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'file_reassignment': json['file_reassignment'] == null ? undefined : IFileReassignmentDtoFromJSON(json['file_reassignment']),
    };
}

export function ILetterOfMedicalNecessityCreateDtoToJSON(json: any): ILetterOfMedicalNecessityCreateDto {
    return ILetterOfMedicalNecessityCreateDtoToJSONTyped(json, false);
}

export function ILetterOfMedicalNecessityCreateDtoToJSONTyped(value?: ILetterOfMedicalNecessityCreateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString()),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString()),
        'document_id': value['document_id'],
        'employee_id': value['employee_id'],
        'claim_ids': value['claim_ids'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'file_reassignment': IFileReassignmentDtoToJSON(value['file_reassignment']),
    };
}

